"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Default layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const header_1 = __importDefault(require("../components/header"));
const footer_1 = __importDefault(require("../components/footer"));
require("../styles/styles.scss");
var DefaultLayout = function DefaultLayout(_ref) {
    var _site$siteMetadata, _site$siteMetadata2;
    var children = _ref.children;
    var _useStaticQuery = gatsby_1.useStaticQuery("194117312"), site = _useStaticQuery.site;
    var avatar = (site === null || site === void 0 ? void 0 : (_site$siteMetadata = site.siteMetadata) === null || _site$siteMetadata === void 0 ? void 0 : _site$siteMetadata.avatar) || '';
    var title = (site === null || site === void 0 ? void 0 : (_site$siteMetadata2 = site.siteMetadata) === null || _site$siteMetadata2 === void 0 ? void 0 : _site$siteMetadata2.title) || '';
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(header_1.default, {
        avatar: avatar
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        id: "content"
    }, children), /*#__PURE__*/ react_1.default.createElement(footer_1.default, {
        siteTitle: title
    }));
};
exports.default = DefaultLayout;
